"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasFeature = hasFeature;
/**
 * Whether a feature flag is enabled for the given organization.
 *
 * Returns false when the organization is missing, has no `features` map, or the
 * flag is absent/disabled — so an undefined flag safely reads as "off".
 */
function hasFeature(organization, feature) {
    return Boolean(organization?.features?.[feature]);
}
